<template>
    <v-dialog v-model="dialog" max-width="1376" scrollable persistent content-class="elevation-0">
        <!-- <v-overlay absolute color="white" opacity="0.3" z-index="12">
            <v-progress-circular indeterminate color="#1DBC97" size="100" width="8"></v-progress-circular>
        </v-overlay> -->
        <v-card class="rounded-xl">
            <v-card-title class="card-title-background-adddoctype py-4">
                <v-row align="center" class="row-page-adddoctype">
                    <v-spacer></v-spacer>
                    <b class="front-headtitle-adddoctype">ลงทะเบียนประเภทเอกสาร</b>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="dialog = false" color="#ffffff">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-row>
            </v-card-title>
            <v-card-text class="px-4 pb-4">
                <v-row align="center" justify="end" class="row-page-adddoctype mt-4">
                    <v-btn height="40px" outlined color="#1DBC97" class="btn-search-adddoctype"
                        @click="openModalAddDoctype()">
                        <v-icon left small>
                            mdi-file-document-plus-outline
                        </v-icon>
                        เพิ่มประเภทเอกสาร
                    </v-btn>
                </v-row>
                <v-row align="center" class="row-page-adddoctype">
                    <v-col align-self="center" cols="12" sm="4" md="3" lg="3" class="pt-4 pb-0 px-0">
                        <v-text-field prepend-inner-icon="mdi-magnify" outlined hide-details dense placeholder="ค้นหา" v-model="search_keyword"
                            class="search-box-adddoctype" color="#1DBC97" background-color="white">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-data-table :headers="table_headers_hcadddoctype" :items="data_table_hcadddoctype" fixed-header
                    :loading="loading" :search="search_keyword"
                    class="mt-4 table-height-adddoctype table-border-adddoctype table-header-adddoctype data-table-adddoctype color-progress-adddoctype">
                    <template v-slot:[`item.edit_delete`]="{ item }">
                        <v-btn icon color="#1dbc97" @click="openModalUpdateDoctype(item)">
                            <v-icon>
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                        <v-btn icon color="red" @click="openModalDeleteAddDoctype(item)">
                            <v-icon>
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <HCModalAddDoctype />
        <HCModalDeleteAddDoctype />
    </v-dialog>
</template>

<script>
import { EventBus } from "../EventBus";
import HCModalAddDoctype from "./ModalAddDoctype.vue";
import HCModalDeleteAddDoctype from "./ModalDeleteAddDoctype.vue"

export default {
    data: () => ({
        dialog: false,
        table_headers_hcadddoctype: [
            {
                text: "Tax ID", align: "center", sortable: false, value: "tax_id", cellClass: "text-start"
            },
            {
                text: "Document Type ID", align: "center", sortable: false, value: "document_id"
            },
            {
                text: "หมายเหตุ", align: "center", sortable: false, value: "remark"
            },
            {
                text: "", align: "center", sortable: false, value: "edit_delete"
            }
        ],
        // data_table_hcadddoctype: [
        //     {
        //         text_id: "01011011", document_id: "78855448", annotation: "ดูทั้งหมด Comment text"
        //     }
        // ],
        data_table_hcadddoctype: [],
        loading: false,
        search_keyword: "",
    }),
    mounted() {
        EventBus.$on("FormHcDashBoardAddDoctype", this.getHcDashboardAddDoctype)
    },
    beforeDestroy() {
        EventBus.$off("FormHcDashBoardAddDoctype")
        // EventBus.$off("FormModalDeleteAddDoctype")
    },
    methods: {
        // getHcDashboardDeleteAddDoctype() {
        //     this.dialog = true;
        // },
        openModalAddDoctype() {
            EventBus.$emit("FormModalAddDoctye","create");
        },
        openModalUpdateDoctype(item) {
            EventBus.$emit("FormModalAddDoctye","update",item);
        },
        openModalDeleteAddDoctype(item) {
            EventBus.$emit("FormModalDeleteAddDoctype",item.tax_id);
        },
        async getHcDashboardAddDoctype() {
            try{
                this.dialog = true;
                this.loading = true

                let url = '/petty_cash/api/v1/get_hc_doctype'
                let { data } = await this.axios.get(this.$api_url + url, { headers: { Authorization: "Bearer " + sessionStorage.getItem("access_token") } })
                if(data){
                    this.data_table_hcadddoctype = data.data
                } 
            }catch(error){
                console.log(error)
            }
            finally{
                this.loading = false
            }
        },
    },
    components: {
        HCModalAddDoctype,
        HCModalDeleteAddDoctype
    }
}
</script>

<style>
.row-page-adddoctype {
    width: 100%;
    margin: 0% !important;
}

.card-title-background-adddoctype {
    background: #1dbc97;
    height: 56px;
}

.front-headtitle-adddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 16px !important;
    color: #ffffff;
    line-height: 22px !important;
}

.text-subtitle-adddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 16px !important;
    color: #333333;
}

.btn-search-adddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 14px !important;
    border-radius: 8px;
    border: 1px solid #e6e6e6 !important;
}

.search-box-adddoctype.v-text-field input {
    line-height: 28px !important;
}

.search-box-adddoctype {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 14px !important;
}

.table-height-adddoctype.v-data-table>.v-data-table__wrapper {
    max-height: calc(100vh - 398px) !important;
    overflow: auto;
}

.theme--light .table-border-adddoctype.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row) {
    border-bottom: 1px solid #f3f5f7 !important;
}

.table-border-adddoctype {
    border: 1px solid #f3f5f7;
    border-radius: 8px !important;
}

.table-header-adddoctype.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #333333 !important;
    background: #f3f5f7;
    text-align: center !important;
    height: 40px !important;
    box-shadow: none !important;
}

.data-table-adddoctype.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    font-family: "Noto Sans Thai", sans-serif;
    font-size: 14px !important;
    color: #464646 !important;
    height: 40px !important;
}

.color-progress-adddoctype>.v-data-table__wrapper>table>thead>.v-data-table__progress>th>.v-progress-linear>.v-progress-linear__background {
    background-color: #1DBC97 !important;
}

.color-progress-adddoctype>.v-data-table__wrapper>table>thead>.v-data-table__progress>th>.v-progress-linear>.v-progress-linear__indeterminate--active>.v-progress-linear__indeterminate {
    background-color: #1DBC97 !important;
}

/* ======================================================================== */

@media only screen and (max-width: 960px) {

    /*css for ipad screen (protrait)*/
    .table-height-adddoctype.v-data-table>.v-data-table__wrapper {
        max-height: calc(100vh - 418px) !important;
    }

}

@media only screen and (max-width: 600px) {

    /*css for mobile screen*/
    .table-height-adddoctype.v-data-table>.v-data-table__wrapper {
        max-height: calc(100vh - 428px) !important;
    }
}
</style>